import React from 'react';
import { Box, Typography, BoxProps } from '@mui/material';

interface FieldsetProps extends BoxProps {
  title?: string;
  children: React.ReactNode;
}

const Fieldset: React.FC<FieldsetProps> = ({ title, children, ...props }) => {
  return (
    <Box
      component="fieldset"
      sx={{
        border: '1px solid #ccc',
        borderRadius: 1,
        padding: 2,
        margin: 0,
      }}
      {...props}
    >
      {title && (
        <Typography
          component="legend"
          sx={{
            fontWeight: 'bold',
            color: '#333',
            fontSize: '13px',
            padding: '0 4px',
          }}
        >
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default Fieldset;
